export default __webpack_public_path__ + "static/media/Slide-4.666141d8.png";